import { Article } from '../types';
import { articlesData } from '../content/articlesData';
import { detailedArticles } from '../content/detailedArticles';
import { detailedArticles2 } from '../content/detailedArticles2';
import { firstLoginArticle } from '../content/firstLoginArticle';
import { companyProfileArticle } from '../content/companyProfileArticle';
import { stripePaymentArticle } from '../content/stripePaymentArticle';
import { convertEstimatesArticle } from '../content/convertEstimatesArticle';
import { inventoryManagementArticle } from '../content/inventoryManagementArticle';

// Combine all articles
const articles: Article[] = [
  firstLoginArticle,
  companyProfileArticle,
  stripePaymentArticle,
  convertEstimatesArticle,
  inventoryManagementArticle,
  ...detailedArticles,
  ...detailedArticles2,
  ...articlesData
];

export const getAllArticles = (): Article[] => {
  return articles;
};

export const getArticle = (category: string, slug: string): Article | undefined => {
  return articles.find(article => 
    article.category === category && article.slug === slug
  );
};

export const getArticlesByCategory = (category: string): Article[] => {
  return articles.filter(article => article.category === category);
};

export const getRelatedArticles = (currentArticle: Article): Article[] => {
  if (!currentArticle.relatedArticles) return [];
  
  return currentArticle.relatedArticles
    .map(slug => articles.find(a => a.slug === slug))
    .filter((a): a is Article => a !== undefined)
    .slice(0, 5);
};